import React from 'react';

import { LoadingPanel } from '../common/LoadingPanel';

import { TestID } from '../../testID';

export const ProvisioningMessage: React.FC = () => (
  <LoadingPanel
    loadingMessage={
      <div className="connect-message-body">
        <div>Provisioning in progress...</div>
        <div>This may take a few minutes.</div>
      </div>
    }
    size="medium"
    testId={TestID.ConnectToSubscriptionProvisioningMessage}
  />
);
